import constants from '../internals/constants';
import urlAppRoot from '../internals/urlAppRoot';
import {RouteStream} from '../libs/Router';
import router from './router';

let origin = constants.CS_CZ;

if (global.location.origin.indexOf('.sk') >= 0 || global.location.origin.indexOf('okna-na-mieru.okna-hned.test') >= 0) {
	origin = constants.SK_SK;
}

if (global.location.origin.indexOf('.de') >= 0 || global.location.origin.indexOf('.eu') >= 0 || global.location.origin.indexOf('massfenster.fenster-jetzt.test') >= 0) {
	origin = constants.DE_DE;
}

if (global.location.origin.indexOf('.at') >= 0) {
	origin = constants.DE_AT;
}

if (global.location.origin.indexOf('.hu') >= 0 || global.location.origin.indexOf('egyedi-ablak.ablakok-most.test') >= 0) {
	origin = constants.HU_HU;
}

let routeStream: RouteStream = router.add(`${urlAppRoot}(/)(:language)(/order)(/:order)(/)`).map((value) => {
	let {language, order} = value;
	let routeString = '';
	
	if (language) {
		routeString += `/${language}`;
	}
	
	if (order) {
		routeString += `/${order}`;
	}
	
	if (!routeString) {
		routeString = '/';
	}
	
	// (global as any).ga('set', 'page', routeString);
	// (global as any).ga('send', 'pageview');
	
	if (typeof window !== 'undefined' && window.history && window.history.state && typeof window.history.state.scroll !== 'undefined') {
		requestAnimationFrame(() => {
			window.scrollTo(0, window.history.state.scroll);
		});
	}
	
	if (language === 'order') {
		language = origin;
	}
	
	if (language !== constants.CS_CZ && language !== constants.SK_SK && language !== constants.DE_DE && language !== constants.DE_AT && language !== constants.HU_HU) {
		order = language;
		language = origin;
	} else if (typeof window !== 'undefined' && language !== origin) {
		let isTest = typeof location !== 'undefined' && location.hostname.indexOf('.test') !== -1;
		let domainMapping = {
			[constants.CS_CZ]: isTest ? 'okna-na-miru.okna-hned.test' : 'okna-na-miru.okna-hned.cz',
			[constants.SK_SK]: isTest ? 'okna-na-mieru.okna-hned.test' : 'okna-na-mieru.okna-hned.sk',
			[constants.DE_DE]: isTest ? 'massfenster.fenster-jetzt.test' : 'massfenster.fenster-jetzt.de',
			[constants.DE_AT]: isTest ? 'massfenster.fenster-jetzt.test' : 'massfenster.fenster-jetzt.at',
			[constants.HU_HU]: isTest ? 'egyedi-ablak.ablakok-most.test' : 'egyedi-ablak.ablakok-most.hu'
		};

		if (domainMapping[language]) {
			let protocol = isTest ? 'http' : 'https';
			let port = typeof location !== 'undefined' && location.port ? `:${location.port}` : '';
			let search = typeof location !== 'undefined' ? location.search : '';

			let path = '';

			if (order) {
				path += `/order/${order}/`;
			} else {
				path += '/';
			}

			window.location.href = `${protocol}://${domainMapping[language]}${port}${path}${search}`;
		}
	}
	
	return {language, order};
});

global.routeStream = routeStream;

export default routeStream;
